import React from "react";
import {
  Button,
  Heading,
  Text,
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
  VStack
} from "@chakra-ui/react";
import { CountryCodeSelect } from "../CountryCodeSelect";

export const ForgotPassword = ({
  username,
  errorMessage,
  showCountryCode,
  onUsernameChange,
  isError,
  isLoading,
  onForgotPasswordSubmit,
  codeChange,
}) => {
  return (
    <VStack spacing={5}>
      <Heading lineHeight={1.1} fontSize="2xl">
        Forgot your password?
      </Heading>
      <Text fontSize={{ base: "sm", sm: "md" }} color="gray.800">
        Enter your Email or Phone number below and we will send a message to
        reset your password
      </Text>
      <form onSubmit={onForgotPasswordSubmit} style={{width: "100%"}}>
        <VStack spacing={5}>
          <FormControl
            padding="0"
            colorScheme="brand"
            isRequired={true}
            isInvalid={isError}
          >
            <FormLabel>Email or Phone number</FormLabel>
            <InputGroup>
              {showCountryCode && <CountryCodeSelect codeChange={codeChange} />}
              <Input
                type="text"
                name="username"
                placeholder="Email or Phone number"
                value={username}
                errorBorderColor="red.300"
                onChange={onUsernameChange}
                disabled={isLoading}
              />
            </InputGroup>
            <FormErrorMessage display="block">{errorMessage}</FormErrorMessage>
          </FormControl>
          <Button
            colorScheme="blue"
            type="submit"
            _hover={{
              bg: "blue.500",
            }}
            width="100%"
            isLoading={isLoading}
            loadingText='Sending code'
          >
            Reset my password
          </Button>
        </VStack>
      </form>
    </VStack>
  );
};
